<template>
  <div>


    <confirm-modal :show="show_confirm_modal" :select_option="select_option" :payment="payment_selected"
      @close="show_confirm_modal = false" @confirm="sendPaymentNotification"></confirm-modal>


    <support-file-modal v-if="show_support_modal" :support_files="selected_support_files"
      :referenceDate="selected_support_date" @closeSupportModal="closeSupportModal()"
      @modifySupportState="modifySupportFileState($event)">
    </support-file-modal>
    <NewPaymentsView v-if="show_new_payments_view" v-model="paymentsLoaded" :paymentsLoaded="paymentsLoaded"
    :download_view="downloads_view" @loadData="sendMultiplePayments"
      @cancelAction="handleClose">
    </NewPaymentsView>
    <form @submit.prevent="applyFilters" class="filter-form">
      <div class="filter-item">
        <select v-model="filters.state" class="filter-select">
          <option value="">Todos los estados</option>
          <option value="PENDING">Pendiente</option>
          <option value="COMPLETED">Completado</option>
        </select>
      </div>
      <div class="filter-item">
        <div class="filter-input-wrapper">
          <span class="filter-icon">
            <i class="fas fa-search"></i>
          </span>
          <input type="text" v-model="filters.userName" placeholder="Buscar usuario" class="filter-input" />
        </div>
      </div>
      <div class="filter-item">
        <div class="filter-input-wrapper">
          <span class="filter-icon">
            <i class="fas fa-dollar-sign"></i>
          </span>
          <input type="text" v-model="filters.minAmount" placeholder="Minimo valor Buscado" class="filter-input" />
        </div>
      </div>


      <!-- Filtro de rango de fechas -->
      <div class="filter-item">
        <div class="filter-input-wrapper">
          <span class="filter-icon">
            <i class="fas fa-calendar"></i>
          </span>
          <v-menu ref="datePickerMenuAgreement" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <input v-model="selectedDateAgreement" placeholder="Fecha de Acuerdo" prepend-icon="mdi-calendar" readonly
                v-on="on" class="filter-input">
            </template>
            <v-date-picker v-model="filters.dateAgreement" no-title scrollable @input="toggleDate('agreement')" />
          </v-menu>
        </div>
      </div>

      <div class="filter-item">
        <div class="filter-input-wrapper">
          <span class="filter-icon">
            <i class="fas fa-calendar"></i>
          </span>
          <v-menu ref="datePickerMenuLimit" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <input v-model="selectedDateLimit" placeholder="Fecha Limite de Pago" prepend-icon="mdi-calendar" readonly
                v-on="on" class="filter-input">
            </template>
            <v-date-picker v-model="filters.dateLimit" no-title scrollable @input="toggleDate('limit')" />
          </v-menu>
        </div>
      </div>

    </form>



    <div class="table_card">

      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs10 lg6 class="head_contain">
            <p class="table_card__head--title">Pagos Pendientes</p>
            <div class="flex" style="margin-left: 20px; max-width: 20%;">
              <date-picker class="configure_property__payments--year_picker" v-model="selected_year" type="year"
                @change="getPayments()" required>
              </date-picker>
            </div>
          </v-flex>
          <v-flex xs10 lg6 class="filter_options">
            <div class="buttom_reload" @click="getPayments()">
              <img src="@/assets/img/icons/refresh-icon.svg" />
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-data-table :headers="options_table.headers_table" :items="filteredPayments" :search="options_table.search"
          :pagination.sync="options_table.pagination">
          <template v-slot:items="props">
            <PaymentsTableRows :payment="props.item" @showSupportFileModal="showSupportFileModal"
              @showConfirmModal="showConfirmModal" @row-clicked="editSublocationUser" />
          </template>
        </v-data-table>
      </div>
    </div>
    <div>

      <v-layout class="button-container">
        <v-btn class="rounded-button" color="primary" @click="downloadExampleExcel">
          Descargar Formato de ejemplo
        </v-btn>
        <v-btn class="rounded-button" color="primary" @click="$refs.fileInput.click()">
          Subir archivo
        </v-btn>
        <input type="file" ref="fileInput" @change="handleFileUpload" style="display: none" />
      </v-layout>
    </div>
  </div>
</template>


<script>

import PaymentsTableRows from './PaymentsTableRow.vue';
import ConfirmModal from './Modals/ConfirmModal.vue';
import NewPaymentsView from './Modals/NewPaymentsView.vue'

export default {
  components: {
    PaymentsTableRows,
    ConfirmModal,
    NewPaymentsView
  },
  data() {
    return {
      //vistas
      selectedDateAgreement: '',
      selectedDateLimit: '',
      show_send_payments_modal: false,
      show_confirm_modal: false,
      show_new_payments_view: false,
      downloads_view: false,

      select_option: false,
      months: [],
      selected_support_files: {},
      selected_support_date: '',
      viewdownload: false,
      newpayments: {},
      paymentsLoaded: [],

      payment_selected: {},
      selected_year: '',
      show_support_modal: false,
      search: '',
      options_table: {
        pagination: {
          sortBy: '',
          rowsPerPage: 10,
        },
        headers_table: [
        {
            text: 'Referencia de Pago',
            align: 'center',
            value: 'attributes.payment_reference'
          },
          {
            text: 'N° Documento',
            align: 'center',
            value: 'attributes.user_rut',
          },

          {
            text: 'Nombre del Usuario',
            align: 'center',
            value: 'attributes.user.name',
          },
          

          {
            text: 'Estado',
            align: 'center',
            value: 'attributes.state',
          },
          {
            text: 'Fecha Limite de Pago',
            align: 'center',
            value: 'attributes.limit_date',
          },
          {
            text: 'Fecha de Acuerdo de pago',
            align: 'center',
            value: 'attributes.payment_agreement_date',
          },
          {
            text: 'Días de Retraso',
            align: 'center',
            value: 'days_overdue',
          },
          {
            text: 'Valor',
            align: 'center',
            value: 'attributes.amount',
          },
          {
            text: 'Locación',
            align: 'center',
          },
          {
            text: 'servicio',
            align: 'center',
          },
          {
            text: 'Acción',
            align: 'justify',
            value: 'action',
          },

        ],

      },
      payments: [],
      filters: {
        state: '',
        minAmount: null,
        userName: '',
        dateAgreement: '',
        dateLimit: '',
      },
    };
  },
  computed: {
    filteredPayments() {
      const { state, minAmount, userName, dateAgreement, dateLimit } = this.filters;

      const format_date_agreement = new Date(dateAgreement);
      format_date_agreement.setDate(format_date_agreement.getDate() + 1);

      const format_date_limit = new Date(dateLimit);
      format_date_limit.setDate(format_date_limit.getDate() + 1);

      return this.payments.filter(payment => {
        const { state: paymentState, amount, user, payment_agreement_date, limit_date } = payment.attributes;

        const matchesState = !state || paymentState === state;
        const matchesMinAmount = minAmount === null || amount >= minAmount;

        const matchesUserName = !userName ||
          (user && (
            (user.name && user.name.toLowerCase().includes(userName.toLowerCase())) ||
            (user.last_name && user.last_name.toLowerCase().includes(userName.toLowerCase()))
          ));

        const matchesDateAgreement = !dateAgreement ||
          (payment_agreement_date && new Date(payment_agreement_date).toDateString() === format_date_agreement.toDateString());

        const matchesDateLimit = !dateLimit ||
          (limit_date && new Date(limit_date).toDateString() === format_date_limit.toDateString());

        return matchesState && matchesMinAmount && matchesUserName && matchesDateAgreement && matchesDateLimit;
      });
    }


  },

  methods: {
    async find_locations() {

      let params = { page: this.page };
      const data = { company: { id: this.getCompany().id } };

      try {
        const response = await this.$http.post('locations/company', { data: this.encrypt(data).toString() }, {
          headers: {
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken(),
          },
          params,
        });

        this.locations = response.body.data;

        this.pages = response.body.meta.pages;

        if (response.body.meta && response.body.meta.authentication_token) {
          this.checkToken(response.body.meta.authentication_token);
        }
      } catch (e) {
        console.error('Error al encontrar locaciones:', e);
        alert(e.message);
      }
    },
    getPayments() {
      const companyId = this.getCompany().id;
      const year = this.selected_year.getFullYear();

      this.$http.get('app/payments/company_payments', {
        headers: {
          "X-Device-ID": this.getDeviceId(),
          "Authorization": 'Bearer ' + this.getUserToken(),
        },
        params: {
          company_id: companyId,
          year: year
        }
      })
        .then(response => {
          this.payments = response.body.data;

          if (response.body.meta && response.body.meta.authentication_token) {
            this.checkToken(response.body.meta.authentication_token);
          }
        })
        .catch(error => {
          console.error('Error al encontrar pagos:', error);
          alert(error.message);
        });
    }
    ,



    handleErrorResponse(response) {
      if (response.body.meta) {
        if (response.body.meta.authentication_token) {
          this.checkToken(response.body.meta.authentication_token);
        }
      }
      if (response.status === 401) {
        this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
        this.updateIsInAlert(true);
      } else {
        this.updateAlertMessage(response.body.errors[0].details);
        this.updateIsInAlert(true);
      }
    },
    showSupportFileModal(payment, support_files) {
      this.show_support_modal = true
      this.selected_support_date = payment.reference_date
      this.selected_support_files = support_files
      this.payment_selected = payment
    },
    toggleAllLocations() {
      if (this.allLocations) {
        this.selectedLocations = this.locations;


      } else {
        this.selectedLocations = [];
        this.paymentsFormat = []
      }
    },


    showConfirmModal(payment) {
      this.payment_selected = payment


      if (payment.attributes.external_link) {
        this.show_confirm_modal = true
        this.selected_month = new Date(payment.attributes.reference_date).getMonth() + 1;
        this.selected_amount = payment.attributes.amount
        this.selected_external_link = payment.attributes.external_link
      } else {
        this.show_send_payments_modal = false
        this.updateAlertMessage("No hay métodos de pago asignados");
        this.updateIsInAlert(true)
      }
    },
    closeModalsView() {
      this.show_new_payments_view = false;
      this.downloads_view = false;

    },
    closeSupportModal() {
      this.show_support_modal = false;
    },
    modifySupportFileState(support_file) {
      let data = {
        payment_id: this.payment_selected.id,
        support_file_id: support_file.support_id,
        approved: support_file.value
      }
      try {
        this.$http.post('payments/update_payment_support_state', { data: this.encrypt(data).toString() },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              "Authorization": 'Bearer ' + this.getUserToken()
            }
          })
          .then(function (response) {
            this.updateAlertMessage(response.body.ans)
            this.updateIsInAlert(true)
            this.show_support_modal = false
            this.getPayments()
            if (response.body.meta != undefined && response.body.meta != null) {
              if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function (response) {
            if (response.body.meta != undefined && response.body.meta != null) {
              if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
      } catch (e) {
        alert(e.message)
      }
    },
    cleanUp() {
      this.select_option = false
      this.selected_sublocations = []
      this.selection_counter = 0
    },
    restoreSendPaymentsModal() {
      this.show_send_payments_modal = false
    },
    editSublocationUser(selected_sublocation) {
      console.log('editando usuario de sublocación:', selected_sublocation)
      this.$router.push({ name: 'sublocation_user', params: { sublocation_id: selected_sublocation } })
    },
    sendMultiplePayments(payments) {
      console.log(payments)


      try {
        this.$http.post('payments/create_massive_payments', { data: this.encrypt(payments).toString() },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              "Authorization": 'Bearer ' + this.getUserToken()
            }
          })
          .then(function (response) {
            if (response.body.meta != undefined && response.body.meta != null) {
              if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token)
              }
            }

            this.updateAlertMessage(response.body.ans)

            // this.$router.push({name: 'configure_property'})
          }, function (response) {
            if (response.body.meta != undefined && response.body.meta != null) {
              if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            this.updateAlertMessage(response.body.ans);
            this.updateIsInAlert(true);
          })
      } catch (e) {
        this.updateAlertMessage(e.message);
        this.updateIsInAlert(true);
      }
      this.show_new_payments_view = false;


    },


    sendPaymentNotification(payment) {

      let data = {
        sublocation_id: payment.attributes.sublocation_id,
        payment_id: payment.id,
        amount: payment.attributes.amount,
        external_link: payment.attributes.external_link,
        concept: "Administración",
        month: new Date(payment.attributes.reference_date).getMonth() + 1,
        year: this.selected_year.getFullYear()
      }

      try {
        this.$http.post('payments/create_payment', { data: this.encrypt(data).toString() },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              "Authorization": 'Bearer ' + this.getUserToken()
            }
          })
          .then(function (response) {
            if (response.body.meta != undefined && response.body.meta != null) {
              if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token)
              }
            }

            this.updateAlertMessage(response.body.ans)

            // this.$router.push({name: 'configure_property'})
          }, function (response) {
            if (response.body.meta != undefined && response.body.meta != null) {
              if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            this.updateAlertMessage(response.body.ans);
            this.updateIsInAlert(true);
          })
      } catch (e) {
        this.updateAlertMessage(e.message);
        this.updateIsInAlert(true);
      }

      this.show_confirm_modal = false;
    },

    getCurrentPaymentMethod() {
      try {
        this.$http.get('payment_methods/find_current',
          {
            params: {
              company: { id: this.getCompany().id }
            },
            headers: {
              "X-Device-ID": this.getDeviceId(),
              "Authorization": 'Bearer ' + this.getUserToken()
            }
          }
        ).then(response => {
          if (response.body.data != null && response.body.data != '') {
            this.updatePaymentMethod(response.body.data.attributes.link)
          } else {
            this.show_send_payments_modal = false
            this.updateAlertMessage("No hay métodos de pago asignados");
            this.updateIsInAlert(true)
          }

          if (response.body.meta != undefined && response.body.meta != null) {
            if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function (response) {
          if (typeof response.body.errors[0].details != "object") {
            alert(response.body.errors[0].details);
          } else {
            let message = []
            for (var key in response.body.errors[0].details) {
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
          if (response.body.meta != undefined && response.body.meta != null) {
            if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })

      } catch (e) {
        alert(e.message)
        if (response.body.meta != undefined && response.body.meta != null) {
          if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
            this.checkToken(response.body.meta.authentication_token)
          }
        }
      }
    },
    handleFileUpload(event) {
      this.show_new_payments_view = true;
      const file = event.target.files[0];
      if (file) {
        // Crear un FileReader para leer el archivo Excel
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheet = workbook.Sheets[workbook.SheetNames[0]]; // Leer la primera hoja del Excel
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 }); // Convertir a JSON

          this.processPaymentsData(jsonData);
        };
        reader.readAsArrayBuffer(file);

      }
      this.$refs.fileInput.value = null;

    },
    processPaymentsData(data) {
      // Mapea los datos del Excel a la estructura requerida
      this.paymentsLoaded = data.slice(1).map((row) => {
        const limit_date=new Date(row[5])
        limit_date.setDate(limit_date.getDate() + 1);

        return {
          document_id: row[1],           // Documento de identificación (ID del pago)
          payment_reference: row[0],     // Referencia del pago
          amount: row[4],                // Monto del pago
          concept: "Pago de administración", // Concepto (fijo o el valor de la celda)
          external_link: this.getPaymentMethod(),   // Enlace externo (puede ser vacío si no existe)
          limit_date: limit_date,            // Fecha límite de pago (asumido en la columna 6)
          location: row[3],              // Sublocación/ubicación
          service: row[6],               // Servicio asociado 
        };
      });

    },
    downloadExampleExcel() {
      // Crear un conjunto de datos de ejemplo
      const data = [
        { factura: '001', documento: '12345', nombre: 'Juan Pérez', locacion: 'Bogotá', monto: 100.50, fechaLimitePago: '2024-11-30', servicio: 'Agua' },
        { factura: '002', documento: '67890', nombre: 'Ana Gómez', locacion: 'Medellín', monto: 150.75, fechaLimitePago: '2024-12-05', servicio: 'Electricidad' },
        // Puedes agregar más filas de datos aquí
      ];

      // Crear un libro de trabajo (workbook)
      const ws = XLSX.utils.json_to_sheet(data);

      // Crear el libro
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Facturas');

      // Generar y descargar el archivo Excel
      XLSX.writeFile(wb, 'facturas_ejemplo.xlsx');
    },

    handleClose() {
      this.closeModalsView();

    },
    toggleDate(filterType) {
      // Verifica si el filtro seleccionado es de tipo acuerdo o límite
      if (filterType === 'agreement') {
        if (this.selectedDateAgreement === this.filters.dateAgreement) {
          this.filters.dateAgreement = null; // Restablece la fecha de acuerdo si ya está seleccionada
          this.selectedDateAgreement = ""; // Limpiar la variable de fecha seleccionada
        } else {
          this.selectedDateAgreement = this.filters.dateAgreement; // Asigna la fecha seleccionada
        }
      } else if (filterType === 'limit') {
        if (this.selectedDateLimit === this.filters.dateLimit) {
          this.filters.dateLimit = null; // Restablece la fecha límite si ya está seleccionada
          this.selectedDateLimit = ""; // Limpiar la variable de fecha seleccionada
        } else {
          this.selectedDateLimit = this.filters.dateLimit; // Asigna la fecha seleccionada
        }
      }
    }



  },
  mounted() {
    this.getCurrentPaymentMethod()
    this.find_locations()
    this.selected_year = new Date()
    this.getPayments()
  },
};
</script>
<style scoped>
.button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 20px;
}

.rounded-button {
  border-radius: 50px;
  min-width: 150px;
}

.filter-form {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  background: rgba(255, 255, 255, 0.064);
  padding: 10px 15px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.filter-item {
  flex: 1;
  min-width: 200px;
}

.filter-input-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 5px 10px;
  background: #f9f9f9;
}

.filter-icon {
  margin-right: 5px;
  color: #999;
  font-size: 14px;
}

.filter-input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 5px;
  font-size: 14px;
}

.filter-input:focus {
  outline: none;
}

.filter-select {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f9f9f9;
  transition: border-color 0.3s;
}

.filter-select:focus {
  border-color: #3178c6;
}

.filter-select:hover,
.filter-input-wrapper:hover {
  border-color: #bbb;
}
</style>


// WEBPACK FOOTER //
// src/components/views/users/payment_status/Index.vue